import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';

export const StyledLayoutContainer = styled.div`
  ${rtl`
`}
`;
